import e, { useState as t, useEffect as r } from "react";
function n(e, t) {
  (null == t || t > e.length) && (t = e.length);
  for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function o(e, t, r, n, o, a, i) {
  try {
    var c = e[a](i),
      u = c.value;
  } catch (e) {
    return void r(e);
  }
  c.done ? t(u) : Promise.resolve(u).then(n, o);
}
function a(e, t, r) {
  return (t = function (e) {
    var t = function (e, t) {
      if ("object" != typeof e || !e) return e;
      var r = e[Symbol.toPrimitive];
      if (void 0 !== r) {
        var n = r.call(e, t || "default");
        if ("object" != typeof n) return n;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === t ? String : Number)(e);
    }(e, "string");
    return "symbol" == typeof t ? t : t + "";
  }(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function i(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function c(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {};
    t % 2 ? i(Object(r), !0).forEach(function (t) {
      a(e, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : i(Object(r)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return e;
}
function u() {
  u = function u() {
    return t;
  };
  var e,
    t = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (e, t, r) {
      e[t] = r.value;
    },
    a = "function" == typeof Symbol ? Symbol : {},
    i = a.iterator || "@@iterator",
    c = a.asyncIterator || "@@asyncIterator",
    l = a.toStringTag || "@@toStringTag";
  function f(e, t, r) {
    return Object.defineProperty(e, t, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), e[t];
  }
  try {
    f({}, "");
  } catch (e) {
    f = function f(e, t, r) {
      return e[t] = r;
    };
  }
  function s(e, t, r, n) {
    var a = t && t.prototype instanceof b ? t : b,
      i = Object.create(a.prototype),
      c = new N(n || []);
    return o(i, "_invoke", {
      value: A(e, r, c)
    }), i;
  }
  function p(e, t, r) {
    try {
      return {
        type: "normal",
        arg: e.call(t, r)
      };
    } catch (e) {
      return {
        type: "throw",
        arg: e
      };
    }
  }
  t.wrap = s;
  var y = "suspendedStart",
    d = "suspendedYield",
    m = "executing",
    h = "completed",
    v = {};
  function b() {}
  function g() {}
  function _() {}
  var w = {};
  f(w, i, function () {
    return this;
  });
  var x = Object.getPrototypeOf,
    O = x && x(x($([])));
  O && O !== r && n.call(O, i) && (w = O);
  var E = _.prototype = b.prototype = Object.create(w);
  function S(e) {
    ["next", "throw", "return"].forEach(function (t) {
      f(e, t, function (e) {
        return this._invoke(t, e);
      });
    });
  }
  function j(e, t) {
    function r(o, a, i, c) {
      var u = p(e[o], e, a);
      if ("throw" !== u.type) {
        var l = u.arg,
          f = l.value;
        return f && "object" == typeof f && n.call(f, "__await") ? t.resolve(f.__await).then(function (e) {
          r("next", e, i, c);
        }, function (e) {
          r("throw", e, i, c);
        }) : t.resolve(f).then(function (e) {
          l.value = e, i(l);
        }, function (e) {
          return r("throw", e, i, c);
        });
      }
      c(u.arg);
    }
    var a;
    o(this, "_invoke", {
      value: function value(e, n) {
        function o() {
          return new t(function (t, o) {
            r(e, n, t, o);
          });
        }
        return a = a ? a.then(o, o) : o();
      }
    });
  }
  function A(t, r, n) {
    var o = y;
    return function (a, i) {
      if (o === m) throw Error("Generator is already running");
      if (o === h) {
        if ("throw" === a) throw i;
        return {
          value: e,
          done: !0
        };
      }
      for (n.method = a, n.arg = i;;) {
        var c = n.delegate;
        if (c) {
          var u = P(c, n);
          if (u) {
            if (u === v) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === y) throw o = h, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = m;
        var l = p(t, r, n);
        if ("normal" === l.type) {
          if (o = n.done ? h : d, l.arg === v) continue;
          return {
            value: l.arg,
            done: n.done
          };
        }
        "throw" === l.type && (o = h, n.method = "throw", n.arg = l.arg);
      }
    };
  }
  function P(t, r) {
    var n = r.method,
      o = t.iterator[n];
    if (o === e) return r.delegate = null, "throw" === n && t.iterator.return && (r.method = "return", r.arg = e, P(t, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), v;
    var a = p(o, t.iterator, r.arg);
    if ("throw" === a.type) return r.method = "throw", r.arg = a.arg, r.delegate = null, v;
    var i = a.arg;
    return i ? i.done ? (r[t.resultName] = i.value, r.next = t.nextLoc, "return" !== r.method && (r.method = "next", r.arg = e), r.delegate = null, v) : i : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, v);
  }
  function T(e) {
    var t = {
      tryLoc: e[0]
    };
    1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
  }
  function B(e) {
    var t = e.completion || {};
    t.type = "normal", delete t.arg, e.completion = t;
  }
  function N(e) {
    this.tryEntries = [{
      tryLoc: "root"
    }], e.forEach(T, this), this.reset(!0);
  }
  function $(t) {
    if (t || "" === t) {
      var r = t[i];
      if (r) return r.call(t);
      if ("function" == typeof t.next) return t;
      if (!isNaN(t.length)) {
        var o = -1,
          a = function r() {
            for (; ++o < t.length;) if (n.call(t, o)) return r.value = t[o], r.done = !1, r;
            return r.value = e, r.done = !0, r;
          };
        return a.next = a;
      }
    }
    throw new TypeError(typeof t + " is not iterable");
  }
  return g.prototype = _, o(E, "constructor", {
    value: _,
    configurable: !0
  }), o(_, "constructor", {
    value: g,
    configurable: !0
  }), g.displayName = f(_, l, "GeneratorFunction"), t.isGeneratorFunction = function (e) {
    var t = "function" == typeof e && e.constructor;
    return !!t && (t === g || "GeneratorFunction" === (t.displayName || t.name));
  }, t.mark = function (e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, _) : (e.__proto__ = _, f(e, l, "GeneratorFunction")), e.prototype = Object.create(E), e;
  }, t.awrap = function (e) {
    return {
      __await: e
    };
  }, S(j.prototype), f(j.prototype, c, function () {
    return this;
  }), t.AsyncIterator = j, t.async = function (e, r, n, o, a) {
    void 0 === a && (a = Promise);
    var i = new j(s(e, r, n, o), a);
    return t.isGeneratorFunction(r) ? i : i.next().then(function (e) {
      return e.done ? e.value : i.next();
    });
  }, S(E), f(E, l, "Generator"), f(E, i, function () {
    return this;
  }), f(E, "toString", function () {
    return "[object Generator]";
  }), t.keys = function (e) {
    var t = Object(e),
      r = [];
    for (var n in t) r.push(n);
    return r.reverse(), function e() {
      for (; r.length;) {
        var n = r.pop();
        if (n in t) return e.value = n, e.done = !1, e;
      }
      return e.done = !0, e;
    };
  }, t.values = $, N.prototype = {
    constructor: N,
    reset: function reset(t) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = e, this.done = !1, this.delegate = null, this.method = "next", this.arg = e, this.tryEntries.forEach(B), !t) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = e);
    },
    stop: function stop() {
      this.done = !0;
      var e = this.tryEntries[0].completion;
      if ("throw" === e.type) throw e.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(t) {
      if (this.done) throw t;
      var r = this;
      function o(n, o) {
        return c.type = "throw", c.arg = t, r.next = n, o && (r.method = "next", r.arg = e), !!o;
      }
      for (var a = this.tryEntries.length - 1; a >= 0; --a) {
        var i = this.tryEntries[a],
          c = i.completion;
        if ("root" === i.tryLoc) return o("end");
        if (i.tryLoc <= this.prev) {
          var u = n.call(i, "catchLoc"),
            l = n.call(i, "finallyLoc");
          if (u && l) {
            if (this.prev < i.catchLoc) return o(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return o(i.finallyLoc);
          } else if (u) {
            if (this.prev < i.catchLoc) return o(i.catchLoc, !0);
          } else {
            if (!l) throw Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return o(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(e, t) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var a = o;
          break;
        }
      }
      a && ("break" === e || "continue" === e) && a.tryLoc <= t && t <= a.finallyLoc && (a = null);
      var i = a ? a.completion : {};
      return i.type = e, i.arg = t, a ? (this.method = "next", this.next = a.finallyLoc, v) : this.complete(i);
    },
    complete: function complete(e, t) {
      if ("throw" === e.type) throw e.arg;
      return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), v;
    },
    finish: function finish(e) {
      for (var t = this.tryEntries.length - 1; t >= 0; --t) {
        var r = this.tryEntries[t];
        if (r.finallyLoc === e) return this.complete(r.completion, r.afterLoc), B(r), v;
      }
    },
    catch: function _catch(e) {
      for (var t = this.tryEntries.length - 1; t >= 0; --t) {
        var r = this.tryEntries[t];
        if (r.tryLoc === e) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            B(r);
          }
          return o;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(t, r, n) {
      return this.delegate = {
        iterator: $(t),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = e), v;
    }
  }, t;
}
function l(e, t) {
  return function (e) {
    if (Array.isArray(e)) return e;
  }(e) || function (e, t) {
    var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (null != r) {
      var n,
        o,
        a,
        i,
        c = [],
        u = !0,
        l = !1;
      try {
        if (a = (r = r.call(e)).next, 0 === t) {
          if (Object(r) !== r) return;
          u = !1;
        } else for (; !(u = (n = a.call(r)).done) && (c.push(n.value), c.length !== t); u = !0);
      } catch (e) {
        l = !0, o = e;
      } finally {
        try {
          if (!u && null != r.return && (i = r.return(), Object(i) !== i)) return;
        } finally {
          if (l) throw o;
        }
      }
      return c;
    }
  }(e, t) || function (e, t) {
    if (e) {
      if ("string" == typeof e) return n(e, t);
      var r = {}.toString.call(e).slice(8, -1);
      return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? n(e, t) : void 0;
    }
  }(e, t) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function f(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var s,
  p = {
    exports: {}
  },
  y = {
    exports: {}
  },
  d = {};
var m,
  h,
  v,
  b,
  g,
  _,
  w,
  x,
  O,
  E,
  S,
  j,
  A,
  P,
  T = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function B() {
  return h || (h = 1, "production" === process.env.NODE_ENV ? y.exports = function () {
    if (s) return d;
    s = 1;
    var e = "function" == typeof Symbol && Symbol.for,
      t = e ? Symbol.for("react.element") : 60103,
      r = e ? Symbol.for("react.portal") : 60106,
      n = e ? Symbol.for("react.fragment") : 60107,
      o = e ? Symbol.for("react.strict_mode") : 60108,
      a = e ? Symbol.for("react.profiler") : 60114,
      i = e ? Symbol.for("react.provider") : 60109,
      c = e ? Symbol.for("react.context") : 60110,
      u = e ? Symbol.for("react.async_mode") : 60111,
      l = e ? Symbol.for("react.concurrent_mode") : 60111,
      f = e ? Symbol.for("react.forward_ref") : 60112,
      p = e ? Symbol.for("react.suspense") : 60113,
      y = e ? Symbol.for("react.suspense_list") : 60120,
      m = e ? Symbol.for("react.memo") : 60115,
      h = e ? Symbol.for("react.lazy") : 60116,
      v = e ? Symbol.for("react.block") : 60121,
      b = e ? Symbol.for("react.fundamental") : 60117,
      g = e ? Symbol.for("react.responder") : 60118,
      _ = e ? Symbol.for("react.scope") : 60119;
    function w(e) {
      if ("object" == typeof e && null !== e) {
        var s = e.$$typeof;
        switch (s) {
          case t:
            switch (e = e.type) {
              case u:
              case l:
              case n:
              case a:
              case o:
              case p:
                return e;
              default:
                switch (e = e && e.$$typeof) {
                  case c:
                  case f:
                  case h:
                  case m:
                  case i:
                    return e;
                  default:
                    return s;
                }
            }
          case r:
            return s;
        }
      }
    }
    function x(e) {
      return w(e) === l;
    }
    return d.AsyncMode = u, d.ConcurrentMode = l, d.ContextConsumer = c, d.ContextProvider = i, d.Element = t, d.ForwardRef = f, d.Fragment = n, d.Lazy = h, d.Memo = m, d.Portal = r, d.Profiler = a, d.StrictMode = o, d.Suspense = p, d.isAsyncMode = function (e) {
      return x(e) || w(e) === u;
    }, d.isConcurrentMode = x, d.isContextConsumer = function (e) {
      return w(e) === c;
    }, d.isContextProvider = function (e) {
      return w(e) === i;
    }, d.isElement = function (e) {
      return "object" == typeof e && null !== e && e.$$typeof === t;
    }, d.isForwardRef = function (e) {
      return w(e) === f;
    }, d.isFragment = function (e) {
      return w(e) === n;
    }, d.isLazy = function (e) {
      return w(e) === h;
    }, d.isMemo = function (e) {
      return w(e) === m;
    }, d.isPortal = function (e) {
      return w(e) === r;
    }, d.isProfiler = function (e) {
      return w(e) === a;
    }, d.isStrictMode = function (e) {
      return w(e) === o;
    }, d.isSuspense = function (e) {
      return w(e) === p;
    }, d.isValidElementType = function (e) {
      return "string" == typeof e || "function" == typeof e || e === n || e === l || e === a || e === o || e === p || e === y || "object" == typeof e && null !== e && (e.$$typeof === h || e.$$typeof === m || e.$$typeof === i || e.$$typeof === c || e.$$typeof === f || e.$$typeof === b || e.$$typeof === g || e.$$typeof === _ || e.$$typeof === v);
    }, d.typeOf = w, d;
  }() : y.exports = (m || (m = 1, "production" !== process.env.NODE_ENV && function () {
    var e = "function" == typeof Symbol && Symbol.for,
      t = e ? Symbol.for("react.element") : 60103,
      r = e ? Symbol.for("react.portal") : 60106,
      n = e ? Symbol.for("react.fragment") : 60107,
      o = e ? Symbol.for("react.strict_mode") : 60108,
      a = e ? Symbol.for("react.profiler") : 60114,
      i = e ? Symbol.for("react.provider") : 60109,
      c = e ? Symbol.for("react.context") : 60110,
      u = e ? Symbol.for("react.async_mode") : 60111,
      l = e ? Symbol.for("react.concurrent_mode") : 60111,
      f = e ? Symbol.for("react.forward_ref") : 60112,
      s = e ? Symbol.for("react.suspense") : 60113,
      p = e ? Symbol.for("react.suspense_list") : 60120,
      y = e ? Symbol.for("react.memo") : 60115,
      d = e ? Symbol.for("react.lazy") : 60116,
      m = e ? Symbol.for("react.block") : 60121,
      h = e ? Symbol.for("react.fundamental") : 60117,
      v = e ? Symbol.for("react.responder") : 60118,
      b = e ? Symbol.for("react.scope") : 60119;
    function g(e) {
      if ("object" == typeof e && null !== e) {
        var p = e.$$typeof;
        switch (p) {
          case t:
            var m = e.type;
            switch (m) {
              case u:
              case l:
              case n:
              case a:
              case o:
              case s:
                return m;
              default:
                var h = m && m.$$typeof;
                switch (h) {
                  case c:
                  case f:
                  case d:
                  case y:
                  case i:
                    return h;
                  default:
                    return p;
                }
            }
          case r:
            return p;
        }
      }
    }
    var _ = u,
      w = l,
      x = c,
      O = i,
      E = t,
      S = f,
      j = n,
      A = d,
      P = y,
      B = r,
      N = a,
      $ = o,
      k = s,
      I = !1;
    function C(e) {
      return g(e) === l;
    }
    T.AsyncMode = _, T.ConcurrentMode = w, T.ContextConsumer = x, T.ContextProvider = O, T.Element = E, T.ForwardRef = S, T.Fragment = j, T.Lazy = A, T.Memo = P, T.Portal = B, T.Profiler = N, T.StrictMode = $, T.Suspense = k, T.isAsyncMode = function (e) {
      return I || (I = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), C(e) || g(e) === u;
    }, T.isConcurrentMode = C, T.isContextConsumer = function (e) {
      return g(e) === c;
    }, T.isContextProvider = function (e) {
      return g(e) === i;
    }, T.isElement = function (e) {
      return "object" == typeof e && null !== e && e.$$typeof === t;
    }, T.isForwardRef = function (e) {
      return g(e) === f;
    }, T.isFragment = function (e) {
      return g(e) === n;
    }, T.isLazy = function (e) {
      return g(e) === d;
    }, T.isMemo = function (e) {
      return g(e) === y;
    }, T.isPortal = function (e) {
      return g(e) === r;
    }, T.isProfiler = function (e) {
      return g(e) === a;
    }, T.isStrictMode = function (e) {
      return g(e) === o;
    }, T.isSuspense = function (e) {
      return g(e) === s;
    }, T.isValidElementType = function (e) {
      return "string" == typeof e || "function" == typeof e || e === n || e === l || e === a || e === o || e === s || e === p || "object" == typeof e && null !== e && (e.$$typeof === d || e.$$typeof === y || e.$$typeof === i || e.$$typeof === c || e.$$typeof === f || e.$$typeof === h || e.$$typeof === v || e.$$typeof === b || e.$$typeof === m);
    }, T.typeOf = g;
  }()), T)), y.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
function N() {
  if (b) return v;
  b = 1;
  var e = Object.getOwnPropertySymbols,
    t = Object.prototype.hasOwnProperty,
    r = Object.prototype.propertyIsEnumerable;
  return v = function () {
    try {
      if (!Object.assign) return !1;
      var e = new String("abc");
      if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;
      for (var t = {}, r = 0; r < 10; r++) t["_" + String.fromCharCode(r)] = r;
      if ("0123456789" !== Object.getOwnPropertyNames(t).map(function (e) {
        return t[e];
      }).join("")) return !1;
      var n = {};
      return "abcdefghijklmnopqrst".split("").forEach(function (e) {
        n[e] = e;
      }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, n)).join("");
    } catch (e) {
      return !1;
    }
  }() ? Object.assign : function (n, o) {
    for (var a, i, c = function (e) {
        if (null == e) throw new TypeError("Object.assign cannot be called with null or undefined");
        return Object(e);
      }(n), u = 1; u < arguments.length; u++) {
      for (var l in a = Object(arguments[u])) t.call(a, l) && (c[l] = a[l]);
      if (e) {
        i = e(a);
        for (var f = 0; f < i.length; f++) r.call(a, i[f]) && (c[i[f]] = a[i[f]]);
      }
    }
    return c;
  }, v;
}
function $() {
  if (_) return g;
  _ = 1;
  return g = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
}
function k() {
  return x ? w : (x = 1, w = Function.call.bind(Object.prototype.hasOwnProperty));
}
if ("production" !== process.env.NODE_ENV) {
  var I = B();
  p.exports = function () {
    if (j) return S;
    j = 1;
    var e = B(),
      t = N(),
      r = $(),
      n = k(),
      o = function () {
        if (E) return O;
        E = 1;
        var e = function e() {};
        if ("production" !== process.env.NODE_ENV) {
          var t = $(),
            r = {},
            n = k();
          e = function e(_e) {
            var t = "Warning: " + _e;
            "undefined" != typeof console && console.error(t);
            try {
              throw new Error(t);
            } catch (e) {}
          };
        }
        function o(o, a, i, c, u) {
          if ("production" !== process.env.NODE_ENV) for (var l in o) if (n(o, l)) {
            var f;
            try {
              if ("function" != typeof o[l]) {
                var s = Error((c || "React class") + ": " + i + " type `" + l + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof o[l] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw s.name = "Invariant Violation", s;
              }
              f = o[l](a, l, c, i, null, t);
            } catch (e) {
              f = e;
            }
            if (!f || f instanceof Error || e((c || "React class") + ": type specification of " + i + " `" + l + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof f + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), f instanceof Error && !(f.message in r)) {
              r[f.message] = !0;
              var p = u ? u() : "";
              e("Failed " + i + " type: " + f.message + (null != p ? p : ""));
            }
          }
        }
        return o.resetWarningCache = function () {
          "production" !== process.env.NODE_ENV && (r = {});
        }, O = o;
      }(),
      a = function a() {};
    function i() {
      return null;
    }
    return "production" !== process.env.NODE_ENV && (a = function a(e) {
      var t = "Warning: " + e;
      "undefined" != typeof console && console.error(t);
      try {
        throw new Error(t);
      } catch (e) {}
    }), S = function S(c, u) {
      var l = "function" == typeof Symbol && Symbol.iterator,
        f = "<<anonymous>>",
        s = {
          array: m("array"),
          bigint: m("bigint"),
          bool: m("boolean"),
          func: m("function"),
          number: m("number"),
          object: m("object"),
          string: m("string"),
          symbol: m("symbol"),
          any: d(i),
          arrayOf: function arrayOf(e) {
            return d(function (t, n, o, a, i) {
              if ("function" != typeof e) return new y("Property `" + i + "` of component `" + o + "` has invalid PropType notation inside arrayOf.");
              var c = t[n];
              if (!Array.isArray(c)) return new y("Invalid " + a + " `" + i + "` of type `" + b(c) + "` supplied to `" + o + "`, expected an array.");
              for (var u = 0; u < c.length; u++) {
                var l = e(c, u, o, a, i + "[" + u + "]", r);
                if (l instanceof Error) return l;
              }
              return null;
            });
          },
          element: d(function (e, t, r, n, o) {
            var a = e[t];
            return c(a) ? null : new y("Invalid " + n + " `" + o + "` of type `" + b(a) + "` supplied to `" + r + "`, expected a single ReactElement.");
          }),
          elementType: d(function (t, r, n, o, a) {
            var i = t[r];
            return e.isValidElementType(i) ? null : new y("Invalid " + o + " `" + a + "` of type `" + b(i) + "` supplied to `" + n + "`, expected a single ReactElement type.");
          }),
          instanceOf: function instanceOf(e) {
            return d(function (t, r, n, o, a) {
              if (!(t[r] instanceof e)) {
                var i = e.name || f;
                return new y("Invalid " + o + " `" + a + "` of type `" + ((c = t[r]).constructor && c.constructor.name ? c.constructor.name : f) + "` supplied to `" + n + "`, expected instance of `" + i + "`.");
              }
              var c;
              return null;
            });
          },
          node: d(function (e, t, r, n, o) {
            return v(e[t]) ? null : new y("Invalid " + n + " `" + o + "` supplied to `" + r + "`, expected a ReactNode.");
          }),
          objectOf: function objectOf(e) {
            return d(function (t, o, a, i, c) {
              if ("function" != typeof e) return new y("Property `" + c + "` of component `" + a + "` has invalid PropType notation inside objectOf.");
              var u = t[o],
                l = b(u);
              if ("object" !== l) return new y("Invalid " + i + " `" + c + "` of type `" + l + "` supplied to `" + a + "`, expected an object.");
              for (var f in u) if (n(u, f)) {
                var s = e(u, f, a, i, c + "." + f, r);
                if (s instanceof Error) return s;
              }
              return null;
            });
          },
          oneOf: function oneOf(e) {
            return Array.isArray(e) ? d(function (t, r, n, o, a) {
              for (var i = t[r], c = 0; c < e.length; c++) if (p(i, e[c])) return null;
              var u = JSON.stringify(e, function (e, t) {
                return "symbol" === g(t) ? String(t) : t;
              });
              return new y("Invalid " + o + " `" + a + "` of value `" + String(i) + "` supplied to `" + n + "`, expected one of " + u + ".");
            }) : ("production" !== process.env.NODE_ENV && a(arguments.length > 1 ? "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])." : "Invalid argument supplied to oneOf, expected an array."), i);
          },
          oneOfType: function oneOfType(e) {
            if (!Array.isArray(e)) return "production" !== process.env.NODE_ENV && a("Invalid argument supplied to oneOfType, expected an instance of array."), i;
            for (var t = 0; t < e.length; t++) {
              var o = e[t];
              if ("function" != typeof o) return a("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + _(o) + " at index " + t + "."), i;
            }
            return d(function (t, o, a, i, c) {
              for (var u = [], l = 0; l < e.length; l++) {
                var f = (0, e[l])(t, o, a, i, c, r);
                if (null == f) return null;
                f.data && n(f.data, "expectedType") && u.push(f.data.expectedType);
              }
              return new y("Invalid " + i + " `" + c + "` supplied to `" + a + "`" + (u.length > 0 ? ", expected one of type [" + u.join(", ") + "]" : "") + ".");
            });
          },
          shape: function shape(e) {
            return d(function (t, n, o, a, i) {
              var c = t[n],
                u = b(c);
              if ("object" !== u) return new y("Invalid " + a + " `" + i + "` of type `" + u + "` supplied to `" + o + "`, expected `object`.");
              for (var l in e) {
                var f = e[l];
                if ("function" != typeof f) return h(o, a, i, l, g(f));
                var s = f(c, l, o, a, i + "." + l, r);
                if (s) return s;
              }
              return null;
            });
          },
          exact: function exact(e) {
            return d(function (o, a, i, c, u) {
              var l = o[a],
                f = b(l);
              if ("object" !== f) return new y("Invalid " + c + " `" + u + "` of type `" + f + "` supplied to `" + i + "`, expected `object`.");
              var s = t({}, o[a], e);
              for (var p in s) {
                var d = e[p];
                if (n(e, p) && "function" != typeof d) return h(i, c, u, p, g(d));
                if (!d) return new y("Invalid " + c + " `" + u + "` key `" + p + "` supplied to `" + i + "`.\nBad object: " + JSON.stringify(o[a], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(e), null, "  "));
                var m = d(l, p, i, c, u + "." + p, r);
                if (m) return m;
              }
              return null;
            });
          }
        };
      function p(e, t) {
        return e === t ? 0 !== e || 1 / e == 1 / t : e != e && t != t;
      }
      function y(e, t) {
        this.message = e, this.data = t && "object" == typeof t ? t : {}, this.stack = "";
      }
      function d(e) {
        if ("production" !== process.env.NODE_ENV) var t = {},
          n = 0;
        function o(o, i, c, l, s, p, d) {
          if (l = l || f, p = p || c, d !== r) {
            if (u) {
              var m = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
              throw m.name = "Invariant Violation", m;
            }
            if ("production" !== process.env.NODE_ENV && "undefined" != typeof console) {
              var h = l + ":" + c;
              !t[h] && n < 3 && (a("You are manually calling a React.PropTypes validation function for the `" + p + "` prop on `" + l + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), t[h] = !0, n++);
            }
          }
          return null == i[c] ? o ? null === i[c] ? new y("The " + s + " `" + p + "` is marked as required in `" + l + "`, but its value is `null`.") : new y("The " + s + " `" + p + "` is marked as required in `" + l + "`, but its value is `undefined`.") : null : e(i, c, l, s, p);
        }
        var i = o.bind(null, !1);
        return i.isRequired = o.bind(null, !0), i;
      }
      function m(e) {
        return d(function (t, r, n, o, a, i) {
          var c = t[r];
          return b(c) !== e ? new y("Invalid " + o + " `" + a + "` of type `" + g(c) + "` supplied to `" + n + "`, expected `" + e + "`.", {
            expectedType: e
          }) : null;
        });
      }
      function h(e, t, r, n, o) {
        return new y((e || "React class") + ": " + t + " type `" + r + "." + n + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + o + "`.");
      }
      function v(e) {
        switch (typeof e) {
          case "number":
          case "string":
          case "undefined":
            return !0;
          case "boolean":
            return !e;
          case "object":
            if (Array.isArray(e)) return e.every(v);
            if (null === e || c(e)) return !0;
            var t = function (e) {
              var t = e && (l && e[l] || e["@@iterator"]);
              if ("function" == typeof t) return t;
            }(e);
            if (!t) return !1;
            var r,
              n = t.call(e);
            if (t !== e.entries) {
              for (; !(r = n.next()).done;) if (!v(r.value)) return !1;
            } else for (; !(r = n.next()).done;) {
              var o = r.value;
              if (o && !v(o[1])) return !1;
            }
            return !0;
          default:
            return !1;
        }
      }
      function b(e) {
        var t = typeof e;
        return Array.isArray(e) ? "array" : e instanceof RegExp ? "object" : function (e, t) {
          return "symbol" === e || !!t && ("Symbol" === t["@@toStringTag"] || "function" == typeof Symbol && t instanceof Symbol);
        }(t, e) ? "symbol" : t;
      }
      function g(e) {
        if (null == e) return "" + e;
        var t = b(e);
        if ("object" === t) {
          if (e instanceof Date) return "date";
          if (e instanceof RegExp) return "regexp";
        }
        return t;
      }
      function _(e) {
        var t = g(e);
        switch (t) {
          case "array":
          case "object":
            return "an " + t;
          case "boolean":
          case "date":
          case "regexp":
            return "a " + t;
          default:
            return t;
        }
      }
      return y.prototype = Error.prototype, s.checkPropTypes = o, s.resetWarningCache = o.resetWarningCache, s.PropTypes = s, s;
    }, S;
  }()(I.isElement, !0);
} else p.exports = function () {
  if (P) return A;
  P = 1;
  var e = $();
  function t() {}
  function r() {}
  return r.resetWarningCache = t, A = function A() {
    function n(t, r, n, o, a, i) {
      if (i !== e) {
        var c = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw c.name = "Invariant Violation", c;
      }
    }
    function o() {
      return n;
    }
    n.isRequired = n;
    var a = {
      array: n,
      bigint: n,
      bool: n,
      func: n,
      number: n,
      object: n,
      string: n,
      symbol: n,
      any: n,
      arrayOf: o,
      element: n,
      elementType: n,
      instanceOf: o,
      node: n,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: r,
      resetWarningCache: t
    };
    return a.PropTypes = a, a;
  };
}()();
var C = f(p.exports);
function L() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];
  return t.filter(Boolean).join(" ");
}
var R = {
  AlertBanner__cont: "AlertBanner-module_AlertBanner__cont__--bE-",
  alert_color: "AlertBanner-module_alert_color__4MbRz",
  info_color: "AlertBanner-module_info_color__dsnOs",
  hidden: "AlertBanner-module_hidden__Br4r7",
  AlertBanner__content: "AlertBanner-module_AlertBanner__content__NTpF4",
  alert_message: "AlertBanner-module_alert_message__6qY64",
  close_btn: "AlertBanner-module_close_btn__GKtWa"
};
!function (e, t) {
  void 0 === t && (t = {});
  var r = t.insertAt;
  if (e && "undefined" != typeof document) {
    var n = document.head || document.getElementsByTagName("head")[0],
      o = document.createElement("style");
    o.type = "text/css", "top" === r && n.firstChild ? n.insertBefore(o, n.firstChild) : n.appendChild(o), o.styleSheet ? o.styleSheet.cssText = e : o.appendChild(document.createTextNode(e));
  }
}('.AlertBanner-module_AlertBanner__cont__--bE- {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  transform: translateY(0);\n  transition: opacity 0.5s ease, transform 0.5s ease;\n  text-align: left;\n}\n.AlertBanner-module_AlertBanner__cont__--bE-.AlertBanner-module_alert_color__4MbRz {\n  background-color: #c8102e;\n}\n.AlertBanner-module_AlertBanner__cont__--bE-.AlertBanner-module_info_color__dsnOs {\n  background-color: #156bac;\n}\n.AlertBanner-module_AlertBanner__cont__--bE-.AlertBanner-module_hidden__Br4r7 {\n  opacity: 0;\n  transform: translateY(-20px);\n  pointer-events: none;\n}\n.AlertBanner-module_AlertBanner__cont__--bE- .AlertBanner-module_AlertBanner__content__NTpF4 {\n  display: flex;\n  align-items: center;\n  max-width: 1440px;\n  width: 100%;\n  padding: 14px 14px 14px 24px;\n}\n@media (max-width: 768px) {\n  .AlertBanner-module_AlertBanner__cont__--bE- .AlertBanner-module_AlertBanner__content__NTpF4 {\n    padding-left: 16px;\n  }\n}\n.AlertBanner-module_AlertBanner__cont__--bE- .AlertBanner-module_AlertBanner__content__NTpF4 .AlertBanner-module_alert_message__6qY64 {\n  flex-grow: 1;\n  font-weight: bold;\n  color: white;\n  font-family: "protipo-narrow";\n  font-size: 18px;\n}\n.AlertBanner-module_AlertBanner__cont__--bE- .AlertBanner-module_AlertBanner__content__NTpF4 .AlertBanner-module_close_btn__GKtWa {\n  flex-shrink: 0;\n  margin-left: 16px;\n  display: inline-block;\n  content: " ";\n  width: 24px;\n  height: 24px;\n  background: url(\'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24"><g id="Group_8313" data-name="Group 8313" transform="translate(-341 -677)" fill="white"><rect id="Rectangle_6" data-name="Rectangle 6" width="24" height="24" transform="translate(341 677)" fill="none"/><path id="Icon_material-close" data-name="Icon material-close" d="M19.5,8.709,18.291,7.5,13.5,12.291,8.709,7.5,7.5,8.709,12.291,13.5,7.5,18.291,8.709,19.5,13.5,14.709,18.291,19.5,19.5,18.291,14.709,13.5Z" transform="translate(339.5 675.5)" fill="white"/></g></svg>\') center center no-repeat;\n  cursor: pointer;\n}');
var M = function M(n) {
  var a = n.position,
    i = n.top,
    f = n.zIndex,
    s = l(t({}), 2),
    p = s[0],
    y = s[1],
    d = l(t(!1), 2),
    m = d[0],
    h = d[1],
    v = l(t(!1), 2),
    b = v[0],
    g = v[1],
    _ = c(c(c({}, a && {
      position: a
    }), i && {
      top: i
    }), f && {
      zIndex: f
    });
  r(function () {
    var e = "www.sportsnet.ca" !== window.location.host ? "int-" : "",
      t = "https://".concat(e, "static-tower.sportsnet.ca/webConfig/webConfig.json");
    function r() {
      var e;
      return e = u().mark(function e() {
        var r, n, o, a;
        return u().wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return e.prev = 0, e.next = 3, fetch(t, {
                method: "GET",
                cache: "no-store"
              });
            case 3:
              return r = e.sent, e.next = 6, r.json();
            case 6:
              if (n = e.sent, o = n.globalAlert) {
                e.next = 10;
                break;
              }
              return e.abrupt("return");
            case 10:
              a = "alert-".concat(o.timestamp), o.active && !localStorage.getItem(a) ? h(!0) : o.active || Object.keys(localStorage).filter(function (e) {
                return e.startsWith("alert-");
              }).forEach(function (e) {
                return localStorage.removeItem(e);
              }), y(o), e.next = 18;
              break;
            case 15:
              e.prev = 15, e.t0 = e.catch(0), console.log(e.t0);
            case 18:
            case "end":
              return e.stop();
          }
        }, e, null, [[0, 15]]);
      }), r = function r() {
        var t = this,
          r = arguments;
        return new Promise(function (n, a) {
          var i = e.apply(t, r);
          function c(e) {
            o(i, n, a, c, u, "next", e);
          }
          function u(e) {
            o(i, n, a, c, u, "throw", e);
          }
          c(void 0);
        });
      }, r.apply(this, arguments);
    }
    !function () {
      r.apply(this, arguments);
    }();
  }, []);
  return e.createElement(e.Fragment, null, m && e.createElement("div", {
    className: L(R.AlertBanner__cont, R["".concat(p.type, "_color")], b ? R.hidden : ""),
    style: _
  }, e.createElement("div", {
    className: R.AlertBanner__content
  }, e.createElement("span", {
    className: R.alert_message
  }, p.message), e.createElement("span", {
    className: R.close_btn,
    onClick: function onClick() {
      g(!0), localStorage.setItem("alert-".concat(p.timestamp), JSON.stringify(!0)), setTimeout(function () {
        h(!1);
      }, 500);
    }
  }))));
};
M.propTypes = {
  position: C.oneOf(["relative", "absolute", "fixed", "sticky"]),
  top: C.number,
  zIndex: C.number
};
export { M as AlertBanner, M as default };